// Organización (cliente) con la que está trabajando el panel. Se fija al entrar, según el perfil del usuario.
// Todas las rutas de Firestore del panel se meten solas dentro de orgs/{org} (ver fs.js).
let ORG = null;
let INFO = {};
const oyentes = new Set();

export const orgActual = () => ORG;
export const infoOrg = () => INFO;

export function fijarOrg(id, info = {}) {
  ORG = id || null;
  INFO = info || {};
  oyentes.forEach((f) => f(INFO));
}

export function alCambiarOrg(f) { oyentes.add(f); return () => oyentes.delete(f); }
